import React from 'react';

import { TestID } from './constants';

export interface Props {
  onClick: () => void;
}

const CancelButton: React.FC<Props> = ({ onClick }) => (
  <button
    className="hover:bg-gray-100 hover:shadow-lg bg-transparent text-blue-200 font-bold py-2 px-12 ml-3 border border-blue-200 rounded text-base"
    data-testid={TestID}
    onClick={onClick}
  >
    Cancel
  </button>
);

export default CancelButton;
